var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isInitiallyLoaded ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.categoryChildren, function(category) {
            return _c(
              "div",
              {
                staticClass: "mb-3 col-6",
                class: "col-md-" + _vm.columnDivider
              },
              [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _c(
                    "div",
                    {
                      staticClass: "nav-item border d-flex",
                      class: { "no-img": _vm.imageSource === "none" }
                    },
                    [
                      category.details[0][_vm.imageSource]
                        ? _c("div", { staticClass: "prop-1-1" }, [
                            _vm.imageSource !== "none"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "/documents/" +
                                      category.details[0][_vm.imageSource],
                                    alt:
                                      category.details[0].metaTitle ||
                                      category.details[0].name
                                  }
                                })
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "nav-text d-flex align-center p-2" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-appearance mx-auto text-truncate"
                            },
                            [_vm._v(_vm._s(category.details[0].name))]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          }),
          _vm._v(" "),
          _vm.categoryChildren.length &&
          _vm.categoryChildren.length < _vm.childrenCount
            ? _c("div", { staticClass: "mb-3 mx-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-appearance px-4 py-3",
                    class: { disabled: _vm.isWaiting },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.loadChunk()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.stepByStepNavigationShowMore"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("icon", {
                      staticClass: "fa-fw",
                      attrs: {
                        icon: "plus-circle",
                        "class-loading": "fa-repeat",
                        loading: _vm.isWaiting
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }